export default __webpack_public_path__ + "static/media/section01NewDesign.42e22820.png";